import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FormBuilder,
  FormGroup
} from '@angular/forms';
import { DataService } from '../../services';

@Component({
  selector: 'app-search-form',
  templateUrl: './search-form.component.html',
  styleUrls: ['./search-form.component.scss']
})
export class SearchFormComponent implements OnInit {
  @Output() search: EventEmitter<any> = new EventEmitter<any>();
  @Input() isDrugsComponent: boolean = false;
  @Input() searchedComponent: 'drugs' | 'medicalTests';
  countryFilters: string[] = [];
  searchForm: FormGroup;
  selectedCountries: string[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private dataService: DataService
    ) { }
  
  ngOnInit(): void {
    this.searchForm = this.formBuilder.group({
      searchInput: ['']
    });
    this.dataService.getLocalCountryFilters().subscribe(countries => {
      if (Array.isArray(countries) && countries.length > 0) {
        this.countryFilters = countries;
      }
    });
  }

  get f() {
    return this.searchForm.controls;
  }

  onCleared() {
    this.searchForm.reset();
    this.dataService.saveLocalSearchCriteria(this.searchForm.value, this.searchedComponent);
  }

  onRefresh() {
    this.onCleared();
    this.countryFilters = [];
    this.selectedCountries = [];
    this.dataService.saveLocalCountryFilters(this.countryFilters);
    this.dataService.saveLocalSelectedCountriesFilters(this.selectedCountries);
  }

  onSubmit() {
    this.search.emit(this.searchForm.value);
    this.dataService.saveLocalSearchCriteria(this.searchForm.value, this.searchedComponent);
  }

  toggleCountrySelection(country: string) {
    const index = this.selectedCountries.indexOf(country);
    if (index === -1) {
      this.selectedCountries.push(country);
    } else {
      this.selectedCountries.splice(index, 1);
    }
    this.dataService.saveLocalSelectedCountriesFilters(this.selectedCountries);
  }
}
